/**
 * Surgery Discharge Information — uses the discharge letter template
 * with a fill-in field for the procedure name.
 */
import { buildDischargeLetter } from '@/frontend/features/printing/documents/discharge/discharge-template.form'

export const surgeryDischarge = buildDischargeLetter({
  id: 'surgery-discharge',
  label: 'Surgery Discharge',
  procedureText: (name) => `${name} has had a general anaesthetic for a`,
  procedureField: true,
})
